import styled from 'styled-components';
import device from '../mediaQueries';
import { fontFamilies } from '../UI/Font';

const UserLink = styled.a`
  ${device.desktop`
    height: 18px;
    color: ${({ color = '#999999' }) => color};
    font-family: ${fontFamilies.light};
    font-size: 15px;
    line-height: 20px;
    cursor: pointer;
    display: inline-table;
    padding: 0 15px;
    && {
      text-decoration: none;
    }
  `}

  ${device.mobile`
    border-radius: 5px;
    margin: 0 15px 15px;
    font-size: 15px;
    font-family: ${fontFamilies.bold};
    line-height: 44px;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ primary }) => (primary ? 'black' : 'white')};
    color: ${({ primary }) => (primary ? 'white' : 'black')};
    ${({ border }) => (border ? 'border: solid 1px #999;' : null)}
  `}
`;

const NavigationLink = styled(UserLink)`
  ${device.all`
    @keyframes appear {
      from {
        opacity: 0;
      }
    }
    
    letter-spacing: 0px;
    font-size: 15px;
    line-height: 18px;
    text-transform: none;
    animation: appear .3s ease-in-out;
    padding: ${({ padding }) => padding || '0 30px 0 0'};
  
    & > span {
      font-size: 15px;
      font-family: ${fontFamilies.bold};
      ${({ underline, color }) => (underline ? `border-bottom: solid 3px ${color || '#000'};` : null)}
    }
  
    cursor: ${({ cursor = 'default' }) => cursor};
    ${({ hoverColor = null }) =>
      hoverColor
        ? `
          &:hover {
            color: ${hoverColor} !important;
          }
          `
        : null}
  `}
`;

const NavigationContentLinkTitle = styled(NavigationLink)`
  ${device.all`
  display: inline-block;
  font-family: ${fontFamilies.bold};

    &::first-letter {
      text-transform: uppercase;
    }
    letter-spacing: 0px;
    font-size: 15px;
    color: ${({ color }) => color || 'black'};
    ${({ href }) => (href ? 'cursor: pointer;' : null)}
    &:hover {
      color: ${({ color }) => color || '#999'};
      ${({ href }) => (href ? 'text-decoration: underline;' : null)}
    }
  `}
  ${device.desktop`
    ${({ paddingLeft }) => (paddingLeft ? `padding-left: ${paddingLeft};` : null)}
  `}
`;

const NavigationContentLink = styled(NavigationContentLinkTitle)`
  ${device.all`
    font-weight: 300;
    letter-spacing: 0px;
    font-family: "Avenir Light", "Arial", sans-serif;
    font-size: 15px;
    text-transform: capitalize;
    margin: ${({ margin }) => margin || '5px 30px 5px 0'};
    &:hover {
      text-decoration: underline;
    }
  `}
`;

export { UserLink, NavigationLink, NavigationContentLink, NavigationContentLinkTitle };
